import React from 'react';
import { ApButtonTab, ApSecondaryNav } from '@alixpartners/ui-components';
import { CategoryPageWrapper, ContentDiv } from './styles';
import { CONFIG } from './routes';
import {
	NavLink,
	Redirect,
	Route,
	Switch,
} from 'react-router-dom/cjs/react-router-dom.min';
import Insights from './Insights/Insights';
import VendorSegmentation from './VendorSegmentation/VendorSegmentation';
import Dashboard from './Dashboard/Dashboard.js';
import CategoryWidget from './CategoryWidget/CategoryWidget';
import withCategoryManagementProviders from './HOCs/withCategoryManagementProviders';
import withCategoryManagementInsightsProviders from './HOCs/withCategoryManagementInsightsProviders';
import withCategoryManagementDashboardProviders from './HOCs/withCategoryManagementDashboardProviders';
import withCategoryManagementVendorSegmentationProviders from './HOCs/withCategoryManagementVendorSegmentationProviders';

const ContentComponent = {
	insights: withCategoryManagementInsightsProviders(Insights),
	dashboard: withCategoryManagementDashboardProviders(Dashboard),
	vendorSegmentation: withCategoryManagementVendorSegmentationProviders(
		VendorSegmentation
	),
	categoryWidget: CategoryWidget,
};

export const CategoryManagement = props => {
	const { location } = props;

	return (
		<CategoryPageWrapper>
			<ApSecondaryNav
				left={
					<React.Fragment>
						{CONFIG.map(({ label, path }) => {
							return (
								<NavLink to={path} key={path}>
									<ApButtonTab isSelected={location.pathname.includes(path)}>
										{label}
									</ApButtonTab>
								</NavLink>
							);
						})}
					</React.Fragment>
				}
			/>
			<ContentDiv>
				<Switch>
					{CONFIG.map(({ name, path }) => {
						return (
							<Route
								key={path}
								path={path}
								component={ContentComponent[name]}
							/>
						);
					})}
					<Redirect to={CONFIG[0].path} />
				</Switch>
			</ContentDiv>
		</CategoryPageWrapper>
	);
};

export default withCategoryManagementProviders(CategoryManagement);
